import { Fragment, memo } from "react";

import type { ReservationDetailForManagementReservationItemQuery } from "@/lib/gql/__generated__/graphql";

import { ApplyPriceText, TotalPeopleText } from "../../../components";

type KidsNum = {
	age: number;
	asCosleeping?: boolean | null;
};

type RoomNum = {
	adultNum: number;
	uniqueRoomID: string;
	kidsNum: Array<KidsNum>;
};

/**
 * @todo QueryData から取得する
 */
type Room = {
	name: string;
	price: number;
	hostInsertedPrice?: number | null;
	discountedPrice?: number | null;
	roomNum: RoomNum;
};

type Props = {
	rooms: Array<Room>;
	onComputeKidsNumDetail: (
		kidsNumDetail: ReservationDetailForManagementReservationItemQuery["reservationDetail"]["kidsNumDetail"],
	) => {
		kidsNum: number;
		kidsNumAsCosleeping: number;
		kidsAgeArray: Array<number>;
	};
};

export const RoomListOfRoomWithOptionCompositions = memo(({ rooms, onComputeKidsNumDetail }: Props) => {
	return (
		<>
			{rooms.map((room, index) => {
				const {
					name,
					roomNum: { adultNum, kidsNum: kidsNumDetail },
					price,
					hostInsertedPrice,
					discountedPrice,
				} = room;

				const { kidsNum, kidsNumAsCosleeping, kidsAgeArray } = onComputeKidsNumDetail(kidsNumDetail);

				return (
					<Fragment key={index}>
						{/* 部屋名 */}
						<p>{name}</p>

						{/* 人数 */}
						<TotalPeopleText
							adultNum={adultNum}
							kidsNum={kidsNum}
							kidsNumAsCosleeping={kidsNumAsCosleeping}
							kidsAgeArray={kidsAgeArray}
							className="text-xs"
						/>

						{/* 金額 */}
						<ApplyPriceText
							hostInsertedPrice={hostInsertedPrice ?? undefined}
							discountedPrice={discountedPrice ?? undefined}
							price={price}
						/>
					</Fragment>
				);
			})}
		</>
	);
});
